<div class="modal-content">

    <div class="modal-header">
        <h4 class="modal-title" id="modal-basic-title">Nueva clase</h4>
        <button tabindex="1" type="button" class="close" aria-label="Close" (click)="_close()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body pl-4">
        <form>

            <div class="form-group">
                <div class="row">
                    <div class="col-md-12">
                        <div class="form-group row d-flex align-items-center" style="margin-bottom: 0px"> <!---->
                            <!---->
                            <label for="fname2" class="col-md-2 label-size tsiLabel mt-2">Clase:</label>

                            <div class="col-md-2">
                                <input style="text-align: center" class="form-control tsiInput" [(ngModel)]="codClase"
                                    name="codClase" type="text" tabindex="2"
                                    onkeypress='return event.charCode >= 48 && event.charCode <= 57' maxlength="3"
                                    disabled>
                            </div>
                            <div class="col-md-7">
                                <select tabindex="3"
                                    class="col-sm-12 focus-input input_border  select_border tsiSelect "
                                    [(ngModel)]="codClase" (change)="onChangeClases($event.target.value)"
                                    name="codClase">
                                    <option *ngFor="let claseSele of listaclases" value="{{claseSele.codigo}}">
                                        {{claseSele.codigo+' - '+claseSele.descri}}
                                    </option>
                                </select>
                            </div>
                            <span style="color: red; font: sans-serif; margin-left: -17px">(*)</span>
                        </div>
                        <div class="form-group row d-flex align-items-center" style="margin-bottom: 0px"> <!---->
                            <!---->
                            <label for="fname2" class="col-md-2 label-size tsiLabel mt-2">Código:</label>

                            <div class="col-md-2">
                                <input style="text-align: center" class="form-control tsiInput"
                                    [(ngModel)]="codCodigoClase" name="codCodigoClase" type="text" tabindex="4"
                                    onkeypress='return event.charCode >= 48 && event.charCode <= 57' maxlength="3">
                            </div>
                            <div class="col-md-7">
                                <select [disabled]="disabledCodigosClaseCombo" tabindex="5"
                                    class="col-sm-12 focus-input input_border  select_border tsiSelect "
                                    [(ngModel)]="codCodigoClase" name="codCodigoClase">
                                    <option *ngFor="let codigoSele of listacodigos" value="{{codigoSele.codigo}}">
                                        {{codigoSele.codigo+' - '+codigoSele.descri}}
                                    </option>
                                </select>
                            </div>
                            <span style="color: red; font: sans-serif; margin-left: -17px">(*)</span>
                        </div>
                    </div>
                </div>

            </div>
        </form>

    </div>
    <div class="modal-footer">

        <button type="button" class="btn btn-rounded btn-success m-b-15" (click)="_ok()" tabindex="6">
            <i class=" fas fa-angle-double-right"></i> Continuar </button>
        <button type="button" class="btn btn-rounded btn-warning m-b-15" (click)="_close()" tabindex="7"><i
                class="fa fa-times-circle"></i>
            Cancelar</button>

    </div>

</div>